// extracted by mini-css-extract-plugin
module.exports = {"swiper":"SwipeBoats_swiper__3ihtj","slide":"SwipeBoats_slide__3uHoG"};